<template>
  <p-container>
    <p-row class="header" align-center>
      <p-button tertiary @click="$router.back()">
        <p-icon>
          keyboard_backspace
        </p-icon>
      </p-button>
      <h2 v-if="page.redebit && !page.redebitDataSource.isLoading">
        #{{ page.redebit.transactionId }}, {{ page.redebit.debtorName }}
      </h2>
    </p-row>
    <p-row v-if="page.redebitDataSource.isLoading || !page.redebit">
      <p-progress-linear :indeterminate="true" />
    </p-row>
    <p-request-alert v-else-if="page.redebitDataSource.error" v-model="page.redebitDataSource.error"></p-request-alert>
    <template v-else>
      <p-row class="redebit">
        <p-col>
          <p-card>
            <h3>{{ $t('page.app.redebit.detail.redebit.title') }}</h3>
            <p-row column dense>
              <div>{{ $t('page.app.redebit.detail.redebit.date') }} : {{ $date(page.redebit.entryDate).format('DD.MM.YYYY HH:mm:ss') }}</div>
              <div>{{ $t('page.app.redebit.detail.redebit.transactionId') }} : {{ page.redebit.transactionId }}</div>
              <div>{{ $t('page.app.redebit.detail.redebit.endToEndId') }} : {{ page.redebit.endToEndId }}</div>
              <div>
                {{ $t('page.app.redebit.detail.redebit.amount') }} :
                <currency-amount :amount="page.redebit.amount" :currency="page.redebit.currency" />
              </div>
              <div>{{ $t('page.app.redebit.detail.redebit.debtor') }} : {{ `${page.redebit.debtorName}, ${page.redebit.debtorAddress}, ${page.redebit.debtorZipCode} ${page.redebit.debtorCity}, ${page.redebit.debtorCountry}` }}</div>
              <div>{{ $t('page.app.redebit.detail.redebit.uploadIcId') }} : {{ page.redebit.uploadIntegrationCallId }} <a v-if="page.redebit.uploadIntegrationCallId" :href="`/_admin/integrationlog/${page.redebit.uploadIntegrationCallId}`"><p-icon>open_in_new</p-icon></a></div>
              <div>{{ $t('page.app.redebit.detail.redebit.uploadState') }} : {{ page.statusCodeToState(page.redebit.uploadStatus) }} {{ page.redebit.uploadStatus !== undefined ? `(${page.redebit.uploadStatus})` : '' }}</div>
              <p-accordion>
                <template #expander="{ expanded }">
                  <p-row align-center>
                    <h4>{{ $t('page.app.redebit.detail.redebit.uploadResponse') }}</h4>
                    <p-icon v-if="expanded">
                      expand_less
                    </p-icon>
                    <p-icon v-else>
                      expand_more
                    </p-icon>
                  </p-row>
                </template>
                <p-code lang="json">
                  {{ page.redebit.uploadStatusResponse }}
                </p-code>
              </p-accordion>
              <div>{{ $t('page.app.redebit.detail.redebit.stateExportAt') }} : {{ page.redebit.uploadStatusReportDownloadDate !== undefined ? $date(page.redebit.uploadStatusReportDownloadDate).format('DD.MM.YYYY HH:mm:ss') : $t('page.app.redebit.detail.redebit.stateExportAt.notExported') }}</div>
            </p-row>
          </p-card>
        </p-col>
      </p-row>
      <p-row class="payment">
        <p-col>
          <p-card>
            <h3>{{ $t('page.app.redebit.detail.payment.title') }}</h3>
            <p-row column dense>
              <div>{{ $t('page.app.redebit.detail.payment.date') }} : {{ page.redebit.paymentRecivedDate !== undefined ? $date(page.redebit.paymentRecivedDate).format('DD.MM.YYYY HH:mm:ss') : '' }}</div>
              <div>{{ $t('page.app.redebit.detail.payment.paymentIcId') }} : {{ page.redebit.paymentIntegrationCallId }} <a v-if="page.redebit.paymentIntegrationCallId" :href="`/_admin/integrationlog/${page.redebit.paymentIntegrationCallId}`"><p-icon>open_in_new</p-icon></a></div>
              <div>{{ $t('page.app.redebit.detail.payment.paymentState') }} : {{ page.translatePaymentState(page.redebit.paymentStatus) }} {{ page.redebit.paymentStatus !== undefined ? `(${page.redebit.paymentStatus})` : '' }}</div>
              <p-accordion>
                <template #expander="{ expanded }">
                  <p-row align-center>
                    <h4>{{ $t('page.app.redebit.detail.payment.paymentResponse') }}</h4>
                    <p-icon v-if="expanded">
                      expand_less
                    </p-icon>
                    <p-icon v-else>
                      expand_more
                    </p-icon>
                  </p-row>
                </template>
                <p-code lang="json">
                  {{ page.redebit.paymentStatusResponse }}
                </p-code>
              </p-accordion>
              <div>{{ $t('page.app.redebit.detail.payment.stateExportAt') }} : {{ page.redebit.paymentStatusReportDownloadDate !== undefined ? $date(page.redebit.paymentStatusReportDownloadDate).format('DD.MM.YYYY HH:mm:ss') : $t('page.app.redebit.detail.payment.stateExportAt.notExported') }}</div>
            </p-row>
          </p-card>
        </p-col>
      </p-row>
    </template>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';
  import RedebitDetailPage from './detail.vue.model';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      page: new RedebitDetailPage(),
    }),
    computed: {
      redebitId() {
        const idParam = this.$router.currentRoute.params.id;
        return Number.parseInt(idParam, 10);
      },
    },
    async beforeMount() {
      this.page.redebitDataSource.filter.id = this.redebitId;
      await this.page.initialize();
    },
  });
</script>
